export const gtmViewItemEvent = (productData: any) => ({
  event: 'view_item',
  currency: 'NOK',
  value: productData.price,
  ecommerce: {
    items: [
      {
        item_id: productData.id,
        item_name: productData.name,
        item_category: productData.category,
        brand: productData.brand,
        affiliation: productData.marketing_material,
        price: productData.price,
        family_id: productData.family_id,
        publicDesignId: productData.publicDesignId,
        customerDesignId: productData.customerDesignId,
        designIdEncLocale: productData.designIdEncLocale,
        priceEUR: productData.priceEUR,
        currency: 'NOK',
        value: productData.unitPrice,
        item_list_id: 'Category Page',
        item_list_name: 'Category Page',
      },
    ],
  },
});

export default gtmViewItemEvent;
